import { render, staticRenderFns } from "./assignmentDelete.vue?vue&type=template&id=7cfef4c2&"
import script from "./assignmentDelete.vue?vue&type=script&lang=js&"
export * from "./assignmentDelete.vue?vue&type=script&lang=js&"
import style0 from "./assignmentDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports